<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" fill="none" viewBox="0 0 19 17"><path stroke="#fff" stroke-width="2" d="M0 8.5h17M9.916.944 17.472 8.5l-7.556 7.555"/></svg>
</template>

<script>
  export default {
    name: "InputArrowRight"
  }
</script>